export function initFrontendSentry() {
  const dsn = String(process.env.REACT_APP_SENTRY_DSN || "").trim();
  if (!dsn) return false;

  import("@sentry/react")
    .then((Sentry) => {
      Sentry.init({
        dsn,
        environment: process.env.NODE_ENV || "development",
        tracesSampleRate: Number(
          process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || 0.05
        ),
      });
    })
    .catch(() => {});

  return true;
}
